/*
		multiselect.js
			Code for large multiselect controls

	To simplify the usage of this class there are some requirements set in stone:
		* There MUST be a <input type="submit" name="submit"> element
		* If a cancelurl is provided then there MUST be a <input type="button" id="cancel">
		* There MUST be a textual element (span,p,...) with id="submitstatus"

 */

var Class = require('./class.js');
var Ajax = require('./ajax.js');
var DOM = require('./dom.js');
var Event = require('./event.js');
var Browser = require('./browser.js');

var MultiSelect = module.exports = Class(null, {
	__init__: function(container, filterplaceholder, list, assigned) {
		this.container = container;
		this.available = list;
		this.current = [];
		for (var i = 0; i < this.available.length; i++)
			this.current.push(this.available[i]['id']);
		this.assigned = assigned;
		this.filtered = [];
		this.scrollBarWidth = this.getScrollBarWidth();
		this.selectto = DOM.SELECT({'multiple': 'true', 'name': 'selectto', 'id': 'selectto'}, '');
		this.fromContainer = DOM.DIV({'className': 'inlinediv'}, '');
		this.filter = DOM.INPUT({'autocomplete': 'off', 'name': 'ignore', 'className': 'vehiclefilter', 'type': 'text', 'placeholder': filterplaceholder});
		this.selectfrom = DOM.SELECT({'multiple': 'true', 'name': 'selectfrom', 'id': 'selectfrom', 'className': 'selectfrom'}, '');

		this.buttonDiv = DOM.DIV({'className': 'multiselect-buttondiv' }, '');
		this.assignall = DOM.BUTTON({'className': 'button blue multibutton', 'title': 'Assign all units', 'type': 'button'}, DOM.SPAN({'className': 'icon-forward'}, ''));
		this.assignselected = DOM.BUTTON({'className': 'button blue multibutton', 'title': 'Assign selected units', 'type': 'button'}, DOM.SPAN({'className': 'icon-chevron-right'}, ''));
		this.unassignall = DOM.BUTTON({'className': 'button blue multibutton', 'title': 'Unassign all units', 'type': 'button'}, DOM.SPAN({'className': 'icon-backward'}, ''));
		this.unassignselected = DOM.BUTTON({'className': 'button blue multibutton', 'title': 'Unassign selected units', 'type': 'button'}, DOM.SPAN({'className': 'icon-chevron-left'}, ''));

		for (var i = 0; i < list.length; i++) {
			var opt = DOM.OPTION({'value': list[i]['id']}, list[i]['name']);
			if (assigned.indexOf(list[i]['id']) == -1)
				DOM.addNodes(this.selectfrom, opt);
			else
				DOM.addNodes(this.selectto, opt);
		}
		DOM.addNodes(this.buttonDiv, this.assignall, DOM.BR(), this.assignselected, DOM.BR(), this.unassignselected, DOM.BR(), this.unassignall);
		if (Browser.isIE6 || Browser.isIE7) {
			this.filter.style.position = 'relative';
			DOM.addNodes(this.container, DOM.LABEL({'className': 'multiselectlabel'}, 'Available'), this.assignLabel = DOM.LABEL({'className': 'multiselectlabel'}, 'Assigned'), DOM.BR(), this.filter, DOM.BR(), this.selectfrom, this.buttonDiv, this.selectto);
		}
		else {
			DOM.addNodes(this.fromContainer, this.filter, this.selectfrom);
			DOM.addNodes(this.container, DOM.LABEL({'className': 'multiselectlabel'}, 'Available'), this.assignLabel = DOM.LABEL({'className': 'multiselectlabel'}, 'Assigned'), DOM.BR(), this.fromContainer, this.buttonDiv, this.selectto);
		}
		Event.observe(this.assignall, 'click', this, this.selectall);
		Event.observe(this.unassignall, 'click', this, this.deselectall);
		Event.observe(this.assignselected, 'click', this, this.selectsome);
		Event.observe(this.unassignselected, 'click', this, this.deselectsome);
		Event.observe(this.filter, 'keyup', this, this.filterselectfrom);
		if (Browser.isIE)
			window.setTimeout(this.setLayout.bind(this), 200);
		else
			this.setLayout();
	},

	updateAvailable: function (updated, list) {
		var toremove = [];
		var toadd = [];
		var available = [];

		for (var i = 0; i < this.available.length; i++)
			available.push(this.available[i]['id']);

		for (var i = 0; i < this.selectfrom.options.length; i++) {
			var opt = this.selectfrom.options[i]
			if (updated.indexOf(Number(opt.value)) == -1)
				toremove.push(opt);
		}

		for (var i = 0; i < this.selectto.options.length; i++) {
			var opt = this.selectto.options[i];
			if (updated.indexOf(Number(opt.value)) == -1)
				toremove.push(opt);
		}

		for (var i = 0; i < toremove.length; i++) {
			var opt = toremove[i];
			var idx = this.current.indexOf(Number(opt.value));
			delete this.current[idx];
			DOM.removeNodes(toremove[i].parentNode, toremove[i]);
		}

		for (var i = 0; i < updated.length; i++) {
			if (this.current.indexOf(updated[i]) == -1) {
				var idx = available.indexOf(updated[i]);
				var toadd = this.available[idx];
				this.current[idx] = toadd['id'];
				var opt = DOM.OPTION({'value': toadd['id']}, toadd['name']);
				this.insertAlphaSorted(this.selectfrom, opt);
			}
		}
	},

	getScrollBarWidth: function() {
		document.body.style.overflow = 'hidden';
		var width = document.body.clientWidth;
		document.body.style.overflow = 'scroll';
		width -= document.body.clientWidth;
		if(!width) width = document.body.offsetWidth - document.body.clientWidth;
		document.body.style.overflow = '';
		return width;
	},

	insertAlphaSorted: function(elem, opt){
		var inserted = false;
		for(var idx = 0; idx < elem.options.length; idx ++){
			if(opt.text < elem.options[idx].text){
				inserted = true;
				DOM.addBefore(elem, elem.options[idx], opt);
				break;
			}
		}
		if(!inserted)
			DOM.addNodes(elem, opt);
	},

	filterselectfrom: function(){
		if(this.filter.value == ''){
			for(var i = 0; i < this.filtered.length; i++)
				this.insertAlphaSorted(this.selectfrom, this.filtered[i]);
			this.filtered = [];
		}
		else{
			for(var idx = this.filtered.length - 1; idx >= 0; idx--){
				if(this.filtered[idx].text.toLowerCase().indexOf(this.filter.value.toLowerCase()) != -1){
					this.insertAlphaSorted(this.selectfrom, this.filtered[idx]);
					this.filtered.splice(idx, 1);
				}
			}
			for(var i = this.selectfrom.options.length - 1; i >= 0; i--){

				var opt = this.selectfrom.options[i];
				if(opt.text.toLowerCase().indexOf(this.filter.value.toLowerCase()) == -1){
					this.filtered.push(opt);
					DOM.removeNodes(this.selectfrom, opt);
				}
			}
		}
	},

	selectall: function(evt){
		toassign = [];
		while(this.selectfrom.hasChildNodes()){
			toassign.push(this.selectfrom.lastChild);
			DOM.removeNodes(this.selectfrom, this.selectfrom.lastChild);
		}
		for(var i = 0; i < toassign.length; i++){
			this.insertAlphaSorted(this.selectto, toassign[i]);
		}
		Event.stop(evt);
	},

	deselectall: function(evt){
		while(this.selectto.hasChildNodes())
			DOM.removeNodes(this.selectto, this.selectto.lastChild);
		DOM.removeChildren(this.selectfrom);
		this.filtered = [];
		for(var i = 0; i < this.current.length; i++){
			if(this.current[i] != undefined){
				var opt = DOM.OPTION({'value': this.available[i]['id']}, this.available[i]['name']);
				DOM.addNodes(this.selectfrom, opt);
			}
		}
		this.filterselectfrom();
		Event.stop(evt);
	},

	selectedsome: function(src, dest){
		toremove = [];
		for(var i = 0; i < src.options.length; i++) {
			if(src.options[i].selected){
				for(var idx = 0; idx < this.current.length; idx++){
					if(this.current[idx] != undefined){
						if(src.options[i].value == this.current[idx])
							toremove.push(src.options[i]);
					}
				}
			}
		}

		for (var idx = 0; idx < toremove.length; idx++) {
			var opt = toremove[idx];
			opt.selected = false;
			DOM.removeNodes(src, opt);
			if(dest.options.length == 0)
				DOM.addNodes(dest, opt);
			else
				this.insertAlphaSorted(dest, opt);
		}
	},

	selectsome: function(evt){
		this.selectedsome(this.selectfrom, this.selectto);
		Event.stop(evt);
	},

	deselectsome: function(evt){
		this.selectedsome(this.selectto, this.selectfrom);
		this.filterselectfrom();
		Event.stop(evt);
	},

	setLayout: function () {
		var xFrom = DOM.getWidth(this.selectfrom);
		var xTo = DOM.getWidth(this.selectto);

		var x = Math.max(xFrom, xTo);
		var filterOffsetWidth = x;

		if (Browser.isIE8)
			filterOffsetWidth -= this.scrollBarWidth;
		else if (Browser.isIE7 || Browser.isIE6) {
			filterOffsetWidth -= 12;
			this.selectfrom.style.display = 'inline';
			this.selectto.style.display = 'inline';
			this.buttonDiv.style.display = 'inline';
		}
		else {
			filterOffsetWidth -= this.scrollBarWidth;
			this.selectfrom.style.borderRight = 'none';
			this.selectto.style.borderRight = 'none';
			filterOffsetWidth -= this.scrollBarWidth;
		}


		this.assignLabel.style.marginLeft = x + 'px';

		DOM.place(this.selectfrom, undefined, undefined, x, 200);
		DOM.place(this.filter, undefined, undefined, filterOffsetWidth); //our input here has some padding that needs accounted for - and it fits inside our 'from list' so we have to measure that too
		DOM.place(this.selectto, undefined, undefined, x, 200);
	}

});

